import axios from "../axiosConfig";

class Routes {
  Create(value) {
    return axios.post("/admin/create", value);
  }
  Get() {
    return axios.get("/admin");
  }
  Delete(id) {
    return axios.delete(`/admin/delete/${id}`);
  }
  Discount(id) {
    return axios.get(`/admin/discount/${id}`);
  }
  Patch(id, data) {
    return axios.patch("/admin/update", { id, data });
  }

  checkPromoCode(id, config = {}) {
    return axios.get(`/admin/promo-code/${id}`, config);
  }
  ActiveStatus(config = {}) {
    return axios.get("/admin/active", config);
  }
}

export default new Routes();
